import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// import Products from './view/Product'

const routes = [
    {
        path: '/index',
        component: () => import('../page/index')
    },
    {
        path: '/H5Page',
        component: () => import('../page/H5Page')
    },
    {
        path: '/defaultPage',
        component: () => import('../page/defaultPage')
    },
    {
        path: '/top',
        component: () => import('../page/top')
    },
    {
        //舌诊专用页面
        path: '/H5Page_AISZ',
        component: () => import('../page/H5Page_AISZ')
    },
    {
        //舌诊充值专用页面
        path: '/H5Page_AISZ_recharge',
        component: () => import('../page/H5Page_AISZ_recharge')
    },

]

const router = new VueRouter({
    routes,
    // mode: 'hash'//'hash' //url路径的模式
})

export default router